<template>
  <Layout>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/LayoutScreen.vue";

export default {
  name: 'HelloWorld',
  components: { Layout },

  props: {
    msg: String
  }
}
</script>
